<template>
  <div class="solicoitorCon">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="证据名称：" prop="nameGZ">
        <el-input v-model="ruleForm.nameGZ" placeholder="请输入要公证合同名称"></el-input>
      </el-form-item>
      <el-form-item label="申请人：" prop="proposer">
        <el-input v-model="ruleForm.proposer" placeholder="请选择"></el-input>
      </el-form-item>
      <el-form-item label="联系电话：" prop="photo">
        <el-input v-model="ruleForm.photo" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="联系邮箱：" prop="email">
        <el-input v-model="ruleForm.email" placeholder="请输入联系邮箱"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="cancalFn">取消</el-button>
        <el-button @click="resetForm('ruleForm')" style="display:none">重置</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" :disabled="isSubmitIng">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
export default {
  data() {
    return {
      isSubmitIng: false,
      ruleForm: {
        nameGZ: "",
        proposer: "",
        photo: "",
        email: ""
      },
      id: [],
      rules: {
        nameGZ: [
          { required: true, message: "请输入要公证合同名称", trigger: "blur" }
        ],
        proposer: [
          { required: true, message: "请选择申请人", trigger: "blur" }
        ],
        photo: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/,
            message: "非手机号格式",
            trigger: "blur"
          }
        ],
        email: [
          { required: true, message: "请输入联系邮箱", trigger: "blur" },
          {
            pattern: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
            message: "非邮箱格式",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.isSubmitIng = true;
      this.$refs[formName].validate(valid => {
        if (valid) {
          var queryStres = {
            name: this.ruleForm.nameGZ,
            contactName: this.ruleForm.proposer,
            contactEmail: this.ruleForm.email,
            contactMobile: this.ruleForm.photo,
            contractIds: this.id
          };
          BaseApi.createRpcToken(
            "/Judiciary/addLawService",
            queryStres,
            "post"
          ).then(
            data => {
              if (data.datas.code == "200") {
                this.$emit("closeHints", true);
                this.$emit("dialogVisibleFn", false);
                setTimeout(() => {
                  this.$emit("closeHints", false);
                  this.$router.replace({
                    path: "/personal/serviceHome",
                    query: {
                      flag: "third"
                    }
                  });
                  this.isSubmitIng = false;
                }, 2000);
              }
              if (data.datas.code == "3602") {
                this.$emit("closeDialog", false);
                this.$emit("hintMessages", true);
                this.resetForm(formName);
                setTimeout(() => {
                  this.isSubmitIng = false;
                  this.$emit("hintMessages", false);
                }, 2000);
                return;
              }
            },
            data => {
              console.log(data);
              this.isSubmitIng = false;
            }
          );
        } else {
          console.log("error submit!!");
          this.isSubmitIng = false;
          return false;
        }
      });
    },
    cancalFn() {
      this.$emit("closeDialog", false);
    },
    setData(arr) {
      this.id = arr;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="scss">
.solicoitorCon {
  width: 100%;
  height: 330px;
  padding: 0 124px;
  box-sizing: border-box;
  padding-top: 44px;
  .el-form-item {
    .el-form-item__label {
      padding: 0;
      line-height: 30px;
      font-size: 12px;
      color: #919191;
      width: 70px !important;
    }
    .el-form-item__content {
      line-height: 30px;
      width: 280px;
      margin-left: 70px !important;
      .el-input {
        .el-input__inner {
          height: 30px;
          line-height: 30px;
          border-radius: 0;
        }
      }
    }
    .el-button {
      width: 100px;
      height: 32px;
      line-height: 32px;
      padding: 0;
      font-size: 12px;
      background-color: #fff;
      color: #646464;
      border: 1px solid #c8c8c8;
      border-radius: 0;
    }
    .el-button--primary {
      color: #db4437;
      border-color: #db4437;
      margin-left: 80px;
    }
    .el-button.is-disabled,
    .el-button.is-disabled:focus,
    .el-button.is-disabled:hover {
      cursor: not-allowed;
      background-image: none;
      background: rgb(220, 220, 220);
      border-color: #ebeef5;
    }
    .el-button--primary:hover {
      color: #fff;
      background-color: #a5303d;
      border-color: #a5303d;
    }
    .el-button:first-child:hover {
      color: #db4437;
      border-color: #db4437;
    }
    .el-button:nth-child(2) {
      float: right;
    }
    .el-form-item.is-required:not(.is-no-asterisk)
      > .el-form-item__label:before {
      content: "*";
    }
  }
}
</style>
